import { graphql } from '@/gql/gql'

export const GET_CHANNEL_BY_DOMAIN_QUERY = graphql(`
  query ChannelByDomain($domain: String!) {
    channelByDomain(domain: $domain) {
      id
      code
      token
      defaultLanguageCode
      availableLanguageCodes
      pricesIncludeTax
      customFields {
        logo {
          preview
        }
        favicon {
          preview
        }
        pwaIcon192 {
          preview
        }
        pwaIcon512 {
          preview
        }
        colors {
          primary
          secondary
          background
          foreground
        }
        fontFamily
        storeDisplayName
        shopIsPublic
        googleTagManagerId
        deliveryDays
      }
    }
  }
`)
